import { IAccountsUser } from './../interfaces/IAccountsuser';
import {Injectable, NgZone} from '@angular/core';
import {RequestService} from './request.service';
import {UrlService} from './url.service';
import {MyCONST} from '../CONST/myCONST';
import {IGroup} from '../interfaces/IGroup';
import {IDistrib} from '../interfaces/IDistrib';
import {IALerteTransFailed, IAuth, IAuthEntreprise, IBankCard} from '../interfaces/IAuth';
import {Router} from '@angular/router';
import {IOption} from '../ui/interfaces/option';
import {Location} from '@angular/common';
import {ISims} from '../interfaces/ISims';
import {IAllowedService, IItemsProviders, IProviders} from '../interfaces/IProviders';
import {IServices} from '../interfaces/IServices';
import {IBuyWallet} from '../interfaces/IBuyWallet';
import {Observable, Subject} from 'rxjs';
import {IPartnerUser, IWalletsPartnerUser, IWalletTransfer} from '../interfaces/IPartnerUser';
import {ITransfer, ITransferBank, IWiresTransfer} from '../interfaces/ITransfer';
import {IDataPartnTransactions} from '../interfaces/IPartnTransactions';
import {IAvailableStock} from '../interfaces/IAvailableStock';
import {IKeys} from '../interfaces/IKeys';
import {IClaims, ISmsBetween, ITransactionsClaims} from '../interfaces/IClaims';
import {IInvitations} from '../interfaces/IInvitations';
import {TranslateService} from '@ngx-translate/core';
import PouchDB from 'pouchdb';
import * as uuid from 'uuid';
import {DeviceDetectorService} from 'ngx-device-detector';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import {IMenuItem} from '../interfaces/main-menu';
import {EnvService} from './env.service';
import {AbstractControl} from '@angular/forms';
import {UserType} from './CONST';
import {ISites} from '../interfaces/ISites';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

export class PasswordValidation {

  static MatchPassword(AC: AbstractControl) {
    const password = AC.get('password').value; // to get value in input tag
    const confirmPassword = AC.get('confirmPassword').value; // to get value in input tag
    if (password !== confirmPassword) {
      console.log('false');
      AC.get('confirmPassword').setErrors({MatchPassword: true});
    } else {
      // console.log('true');
      return null;
    }
  }
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  public loading = false;
  public loading2 = false;
  public authenticated: IAuth = {}; //
  public auth_event = new Subject<boolean>();
  public pagination_event = new Subject<any>();

  // group view
  public Groupes: IGroup[] = [];
  public selected_group: IGroup = {};
  public groupToDelete: IGroup = {};
  groupsdDataChanged: Subject<any>;


  // distributor view
  public Distributors: IDistrib[] = [];
  public all_Distributors: IDistrib[] = [];
  public all_select_Distributors: IOption[] = [];
  public selected_distributor: IDistrib = {};
  distDataChanged: Subject<any>;

  //gestion account
  public accountsUser: IAccountsUser[] =[];
  accountsDataChanged: Subject<any>;


  // sim view
  public sims: ISims[] = [];
  simsDataChanged: Subject<any>;

  // service view
  servicesDataChanged: Subject<any>;
  public all_services: IServices[] = [];
  public all_select_services: IOption[] = [];

  // provider view
  public all_serv_providers: IProviders[] = [];
  public all_select_serv_providers: IOption[] = [];
  providersDataChanged: Subject<any>;


  // provider-items views
  public list_buy_margin: IBuyWallet[] = [];
  public temp_list_buy_margin: IBuyWallet[] = [];
  public list_win_margin: IBuyWallet[] = [];
  public temp_list_win_margin: IBuyWallet[] = [];
  marginDataChanged: Subject<any>;

  // sites view
  public all_sites: ISites[] = [];
  sitesDataChanged: Subject<any>;

  public service_providers: IProviders[];
  public select_service_providers: IOption[];
  public select_service_provider: IOption[];

  public selected_provider: IProviders = {};
  public selected_provider_index: number;
  public provider_event = new Subject<boolean>();

  public selected_service_items: IItemsProviders = {};


  // partners
  public partnerUsers: IPartnerUser[] = [];
  public clientUsers: IPartnerUser[] = [];
  public partnerUsers2: IPartnerUser[] = [];
  partnerDataChanged: Subject<any>;
  clientDataChanged: Subject<any>;
  partner2DataChanged: Subject<any>;


  public partnerTransfers: ITransfer[] = [];
  public receivedWiresTransfers: IWiresTransfer[] = [];
  public sentWiresTransfers: IWiresTransfer[] = [];
  public banckOprations: ITransferBank[] = [];
  // transsactions
  public partnerTransactions: IDataPartnTransactions[] = [];
  transactionsDataChanged: Subject<any>;


  public partnerServicesProv: IProviders[] = [];
  public partnerServicesItems: IItemsProviders[] = [];
  public partnerAllowedServices: IAllowedService[] = [];

  // available stock
  public AvailableStock: IAvailableStock[] = [];
  availableStockDataChanged: Subject<any>;

  public http_event = new Subject<any>();
  public lang_event = new Subject<any>();
  public user_event = new Subject<any>();
  public batch_event = new Subject<any>();

  public defaultLng = 'fr';

  public myServices: IWalletsPartnerUser[] = [];

  // society agents
  public society_agents: IAuth[] = [];
  society_agentsDataChanged: Subject<any>;

  public walletTransfers: IWalletTransfer[] = [];

  public alertTransationFailed: IALerteTransFailed = {};

  public receivedTransfers: ITransfer[] = [];
  public total_receivedTransfers = 0;

  public url_ipn_data: { value?: string } = {};

  // API Keys
  public list_keys: IKeys[] = [];
  apiKeysDataChanged: Subject<any>;


  public list_invitations: IInvitations[] = [];
  public list_free_user_to_invite: IAuthEntreprise[] = [];

  // seller agents
  seller_agents: IPartnerUser[] = [];
  sellerAgentsDataChanged: Subject<any>;

  // claims
  list_claims: IClaims[] = [];
  listClaimsDataChanged: Subject<any>;
  selected_claim: IClaims = {};
  claims_sms_between: ISmsBetween[] = [];
  transactions_byClaims: ITransactionsClaims[] = [];
  transactions_byAgent: IDataPartnTransactions[] = [];
  filterClaimTransID: any;
  default_msg = 'Opération reussie';

  // supervisors
  list_supervisors: IPartnerUser[] = [];
  supervisorsDataChanged: Subject<any>;


  list_agentXcash: IPartnerUser[] = [];

  exchange_services_value:any


  notifications: any[] = [];
  claim_loading_status = false;

  public pendingTrans_db: any;
  public pendingPaymnt_db: any;
  public pendingUsers_db: any;
  public pendingClaims_db: any;
  public pendingClaimsStatus_db: any;

  public isTransDBInstantiated: boolean;
  public isPaymntDBInstantiated: boolean;
  public isUserDBInstantiated: boolean;
  public isClaimDBInstantiated: boolean;
  public isClaimStatusDBInstantiated: boolean;

  public navigator_db: any;
  public isNavigatorDBInstantiated: boolean;
  public navigator_key;

  latitude = 0;
  longitude = 0;
  raw_menuItems: IMenuItem[] = [];
  menuItems: IMenuItem[] = [];

  list_bank_cards: IBankCard[] = [];
  selected_card: IBankCard;

  /**
   * user types
   */

  super_admin = ['home', 'groupes', 'services', 'settings', 'supervisors', 'agents-cash'];
  supervisor = ['claims', 'notifications', 'account-transfer', 'settings', 'my-services'];
  admin = ['home', 'invitations', 'partners' , 'availables-services', 'account-transfer',
    'settings', 'my-services']; // , 'sims-statistics'];
  partner = ['home', 'seller_admin', 'client', 'partners2', 'transactions', 'recharges-stripe', 'keys', 'transfers', 'account-transfer',
    'settings', 'my-services'];
  partner2 = ['home', 'transactions', 'keys', 'settings'];
  seller_admin = ['portal', 'transactions', 'recharges-stripe' , 'transfers', 'seller_agent', 'account-transfer',
    'settings', 'my-services'];
  seller = ['portal', 'transactions', 'account-transfer',
    'settings'];
  client = ['portal', 'transactions', 'recharges', 'account-transfer',
    'settings', 'client_fnf'];

  constructor(private  _request: RequestService, private translate: TranslateService,
              private url: UrlService, private _ngZone: NgZone, private router: Router,
              private location: Location, private deviceService: DeviceDetectorService,
              private  env: EnvService) {

    this.groupsdDataChanged = new Subject();
    this.distDataChanged = new Subject();
    this.accountsDataChanged= new Subject();
    this.simsDataChanged = new Subject();
    this.servicesDataChanged = new Subject();
    this.providersDataChanged = new Subject();
    this.marginDataChanged = new Subject();
    this.sitesDataChanged = new Subject();
    this.supervisorsDataChanged = new Subject();
    this.partnerDataChanged = new Subject();
    this.clientDataChanged = new Subject();
    this.partner2DataChanged = new Subject();
    this.availableStockDataChanged = new Subject();
    this.apiKeysDataChanged = new Subject();
    this.transactionsDataChanged = new Subject();
    this.society_agentsDataChanged = new Subject();
    this.sellerAgentsDataChanged = new Subject();
    this.listClaimsDataChanged = new Subject();
    /*
   translate configs
    */
    // this.configDEfaultLang();
    /* this.translate.get('HOME.txt.success_operation_msg').subscribe(res => {
       console.log('translate result', res);
       this.default_msg = res;
     });*/
  }

  initPendingTransactionDB() {
    if (!this.isTransDBInstantiated) {
      this.pendingTrans_db = new PouchDB(this.authenticated.id + '_' + MyCONST.PENDING_TRANSACTIONS_DB);
      this.isTransDBInstantiated = true;
    }

    if (!this.isPaymntDBInstantiated) {
      this.pendingPaymnt_db = new PouchDB(this.authenticated.id + '_' + MyCONST.PENDING_PAYMENTS_DB);
      this.isPaymntDBInstantiated = true;
    }

    if (!this.isUserDBInstantiated) {
      this.pendingUsers_db = new PouchDB(this.authenticated.id + '_' + MyCONST.PENDING_USERS_DB);
      this.isUserDBInstantiated = true;
    }
    if (!this.isClaimDBInstantiated) {
      this.pendingClaims_db = new PouchDB(this.authenticated.id + '_' + MyCONST.PENDING_CLAIMS_DB);
      this.isClaimDBInstantiated = true;
    }

    if (!this.isClaimStatusDBInstantiated) {
      this.pendingClaimsStatus_db = new PouchDB(this.authenticated.id + '_' + MyCONST.PENDING_CLAIMS_STATUS_DB);
      this.isClaimStatusDBInstantiated = true;
    }

  }

  initNavigatorDB() {
    if (!this.isNavigatorDBInstantiated) {
      this.navigator_db = new PouchDB(this.authenticated.id + '_' + MyCONST.NAVIGATOR_DB);
      this.isNavigatorDBInstantiated = true;
      this.get_navigator_key();
    }
  }

  get_navigator_key() {
    this.navigator_db.allDocs({include_docs: true, descending: true}, (err, doc) => {
      const toSend = {_id: uuid.v4(), timestamp: Date()};
      const rows = doc.rows;
      // console.log(rows);
      if (rows.length === 0) {
        this.navigator_db.put(toSend);
      } else {
        this.navigator_key = rows[0].id;
      }
      // this..pendingTrans_db.put(toSend);
    });
  }

  processPendingTransactions() {
    const that = this;
    this.pendingTrans_db.allDocs({include_docs: true, descending: false}, function (err, doc) {
      const rows: any[] = doc.rows;
      // console.log('doc', doc, rows);
      const allPromise = [];
      const allData = [];
      let count_pending = 0;
      rows.forEach(async (row) => {
        const data = {...row.doc};
        try {
          data.api_key = that.authenticated.attached_api_key.value || row.doc.api_key;
        } catch (e) {
          data.api_key = '';
        }
        delete data._id;
        delete data.status;
        delete data._rev;
        const _id = row.doc._id;
        const _status = row.doc.status;
        console.log('status', _status, _id);

        if (_status === 'pending') {
          allPromise.push(that.async_sendCreditByApiKey(null, data).then(res => {
            console.log('payment done');
            const clone_data = {...data};
            delete clone_data.password;
            allData.push(clone_data);
            count_pending++;
            return _id;
          }).catch(e => {
            return _id;
          }));
        }
      });

      Promise.all(allPromise).then(ids => {
        console.log('allpromise', ids);
        that.deletePending_id(ids, 'pendingTrans_db');
        let dataSt;
        const title = 'Bulk Transactions result';
        if (count_pending > 0) {
          that.exportAsExcelFile(allData, 'bulk_transactions');
          that._request.notifySuccess('info', '', count_pending + ' Pending transactions processed');
          console.log('refreshing data ....');
          that.refreshUserInfo();
          dataSt = {
            title, status: true,
            texts: [`Transactions sent : ${ids.length}`, `Transactions processed : ${count_pending}`]
          };
          that.get_partner_transactions(that.authenticated.account.id,
            1, that.authenticated.type, that.authenticated.attached_api_key_id);
        } else {
          if (ids.length !== 0) {
            dataSt = {count: 0};
            that._request.notifySuccess('error', '', ' No transactions processed');
            dataSt = {
              title, status: false,
              texts: [`Transactions sent : ${ids.length}`, `Transactions processed : ${count_pending}`]
            };
          }
        }
        that.batch_event.next(dataSt);
      }).catch(e => {
        console.log('allpromise error', e);
      });

    });
  }

  processPending(type, selected_db: string, srcUrl = null) {
    const that = this;
    this[selected_db].allDocs({include_docs: true, descending: false}, async function (err, doc) {
        const rows: any[] = doc.rows;
        const allPromise = [];
        const allData = [];
        let count_pending = 0;
        let title = '';
        for (let row of rows) {
          const data = {...row.doc};
          console.log('payments pending', data);
          delete data._id;
          delete data.status;
          delete data._rev;
          delete data.account_id;
          const _id = row.doc._id;
          const _status = row.doc.status;
          const _account_id = row.doc.account_id;
          console.log('status', _status, _id);
          let res;
          if (_status === 'pending') {

            try {
              switch (type) {
                case MyCONST.PENDING_USERS:
                  title = 'Users';
                  res = await that.async_addPartner(null, data);
                  break;
                case MyCONST.PENDING_PAYMENTS:
                  title = 'Payments';
                  res = await that.async_verserPartner(null, _account_id, data);
                  break;
                case MyCONST.PENDING_CLAIMS:
                  title = 'Claims';
                  res = await that.async_transClainTransfer(null, data);
                  break;
              }

              console.log('async request done', res);
              const clone_data = {...data};
              allData.push(clone_data);
              count_pending++;

            } catch (e) {
              console.log('error async request', e);
            }
          } else {
            try {
              switch (type) {
                case MyCONST.PENDING_CLAIMS_STATUS:
                  const form_data = {...data};
                  delete form_data.claim_id;
                  delete form_data.claim_status;
                  form_data.status = data.claim_status;
                  const claim_id = data.claim_id;
                  title = 'Claims Status ';
                  res = await that.async_updateClaimValidateStatus(null, claim_id, form_data);

                  break;
              }

              console.log('async request done', res);
              const clone_data = {...data};
              allData.push(clone_data);
              count_pending++;

            } catch (e) {
            }
          }
          allPromise.push(_id);

        }

        try {
          const ids = await Promise.all(allPromise);
          console.log('allpromise', ids);
          that.deletePending_id(ids, selected_db);
          let dataSt;
          const head_title = title + ' Bulk Result';
          if (count_pending > 0) {
            that.exportAsExcelFile(allData, 'bulk_' + title + '_result');
            that._request.notifySuccess('info', '', count_pending + ' Pending ' + title + ' processed');
            dataSt = {
              title: head_title, status: true,
              texts: [`${title} sent : ${ids.length}`, `${title} processed : ${count_pending}`]
            };

            switch (type) {
              case MyCONST.PENDING_USERS:
                that.getSellerAgents();
                break;
              case MyCONST.PENDING_PAYMENTS:
                that.refreshUserInfo();
                if (srcUrl === 'seller_admin') {
                  that.partnerDataChanged.next();
                } else{
                  if(srcUrl === 'client'){
                    that.clientDataChanged.next();
                  }else {
                    that.partner2DataChanged.next();
                  }
                }
                break;
            }
          } else {
            if (ids.length !== 0) {
              dataSt = {count: 0};
              that._request.notifySuccess('error', '', 'No ' + title + ' processed');
              dataSt = {
                title, status: false,
                texts: [`${title} sent : ${ids.length}`, `${title} processed : ${count_pending}`]
              };
            }
          }
          that.batch_event.next(dataSt);
        } catch (e) {
          console.log('allpromise error', e);
        }

      }
    );
  }

  cleanLocalData(key: string, storageK: string) {
    this[key] = [];
    localStorage.removeItem(storageK);
  }

  checkDataAvalaible(key: string, storageK: string): boolean {
    /*
    get user info from localStorage
     */
    let data_length = Object.keys(this[key]).length;
    if (data_length === 0) {
      const localData = JSON.parse(localStorage.getItem(storageK));
      this[key] = (localData) ? localData : {};
    }

    data_length = Object.keys(this[key]).length;
    // console.log('Data found', key, this[key], data_length);

    return data_length > 0;
  }

  getUserInfo(process = false): Promise<any> {
    let r: Observable<any> = new Observable<any>();
    if (!process && this.checkDataAvalaible('authenticated', MyCONST.authenticated)) {
      return new Promise((resolve, reject) => resolve(r));
    }
    console.log('get user info');
    const requestURL = this.url.baseurl + 'auth/me';
    this.loading = true;
    r = this._request.get(requestURL);


    return r.toPromise().then((results: any) => {
      this.loading = false;
      console.log(results);
      this.authenticated = results;
      if (this.env.set_profile_test) {
        this.authenticated.type = this.env.profile_test;
      }

      localStorage.setItem(MyCONST.authenticated, JSON.stringify(this.authenticated));
      console.log(this.authenticated, Object.keys(this.authenticated).length);
      return results;
    });


  }

  refreshUserInfo(that = null) {
    console.log('get user info');
    const requestURL = this.url.baseurl + 'auth/me';
    this.loading = true;
    return this._request.get(requestURL).toPromise().then((results: any) => {
      this.loading = false;
      // console.log(results);
      this.authenticated = results;

      if (this.env.set_profile_test) {
        this.authenticated.type = this.env.profile_test;
      }

      localStorage.setItem(MyCONST.authenticated, JSON.stringify(results));
      // console.log(this.authenticated, Object.keys(this.authenticated).length);
      if (that === null) {
        return results;
      }

      that.onUserLoad();
      return results;
    });
  }

  processData(type: string, that, Url: string, body: any, json_only: boolean = false) {
    let req;
    switch (type) {
      case 'put':
        req = this._request.put(Url, body, json_only);
        break;
      case 'delete':
        req = this._request.delete(Url);
        break;

      case 'post':
        req = this._request.post(Url, body);
        break;
      case 'async_post':
        req = this._request.async_post(Url, body);
        break;
      case 'async_put':
        req = this._request.async_put(Url, body);
        break;
      default:
        req = this._request.post(Url, body);
        break;
    }

    return req.toPromise().then((results: any) => {
        this.loading = false;
        console.log('http response', results);
        if (type !== 'async_post') {
          this._request.notifySuccess('success', 'Notification', this.default_msg);
        }
        if (that) {
          that.onSuccess();
        }
        return results;
      }
    ).catch((e) => e.message);
  }


  get_stored_element(element: string, local_index: string): boolean {
    const local_data: IGroup = JSON.parse(localStorage.getItem(local_index));
    this[element] = (local_data) ? local_data : {};
    return !!(local_data);
  }

  get_stored_array(element: string, local_index: string): boolean {
    const local_data: IGroup = JSON.parse(localStorage.getItem(local_index));
    this[element] = (local_data) ? local_data : [];
    return !!(local_data);
  }


  get_filter_service_provides(that = null) {
    this.service_providers = [];
    const Url = this.url.baseurl + 'auth/' + this.authenticated.type + '/service_providers';
    this._request.get(Url).subscribe((res: any) => {
      console.log('sims data', res);
      this.service_providers = res;
      this.select_service_providers = [];
      this.service_providers.forEach((v, k) => {
        this.select_service_providers.push({label: v.name, value: v.id, img: v.logo});
      });

      if (that != null) {
        that.filter_data();
      }
    });
  }

  /////////////


  get_filterr_service_provides(): Observable<IOption>{
    this.service_providers = [];
    var subject = new Subject<any>();
    const Url = this.url.baseurl + 'auth/' + this.authenticated.type + '/service_providers';
     this._request.get(Url).subscribe((res: any) => {
      this.service_providers = res;
      this.select_service_providers = [];
      this.service_providers.forEach((v, k) => {
        this.select_service_providers.push({label: v.name, value: v.id, img: v.logo});

      });
      subject.next(this.select_service_providers);

    });

    return subject.asObservable();


  }
  /////////////

  get_all_servProviders(refresh = false) {
    this.all_serv_providers = [];
    const Url = this.url.baseurl + 'auth/super_admin/service_providers';
    this.loading2 = true;
    this._request.get(Url).subscribe((res: any) => {
      console.log('all providers data', res);
      this.all_serv_providers = res;
      this.all_select_serv_providers = [];
      this.all_serv_providers.forEach((v, k) => {
        this.all_select_serv_providers.push({label: v.name, value: v.id, img: v.logo});
      });

      localStorage.setItem(MyCONST.ALL_SERV_PROVIDERS, JSON.stringify(this.all_serv_providers));
      localStorage.setItem(MyCONST.ALL_SELECT_SERV_PROVIDERS, JSON.stringify(this.all_select_serv_providers));
      if (refresh) {
        this.provider_event.next(true);
      }
      this.loading2 = false;
    });
  }

   get_exchange_for_services(service_item_id, accountId = 0) {
    const Url = this.url.baseurl + 'auth/service_item/' + service_item_id + '/services_exchange/' + accountId;
    this._request.get(Url).subscribe((res: any) => {
      //console.log('RES ===> ', res)
      this.exchange_services_value = res
    });
  }


  get_item_fields(type, service_item_id, accountId = 0) {
    this['list_' + type] = [];
    const Url = this.url.baseurl + 'auth/service_item/' + service_item_id + '/' + type + '/' + accountId;
    this._request.get(Url).subscribe((res: any) => {
      console.log('buy wallets data', res);
      this['list_' + type] = res;
    });
  }

  get_partner_transfer(accountId: number) {
    this.partnerTransfers = [];
    const Url = this.url.baseurl + 'auth/accounts/' + accountId + '/transferPro';
    this.loading = true;
    this._request.get(Url).subscribe((res: any) => {
      this.partnerTransfers = res.transfers;
      this.loading = false;

      this.partnerTransfers.forEach(value => {
        this.total_receivedTransfers += value.amount;
      });
    });
  }


  get_partner_servicesProv(): Promise<any> {
    this.partnerServicesItems = [];
    this.partnerServicesProv = [];
    this.select_service_providers = [];
    const Url = this.url.baseurl + 'auth/service_providers';
    this.loading = true;
    return this._request.get(Url).toPromise().then((res: any) => {
      this.partnerServicesProv = res;
      console.log('services providers', res);
      this.partnerServicesProv.forEach((v) => {
        this.select_service_providers.push({label: v.name, value: v.id, img: v.logo});

        v.items.forEach((i) => {
          this.partnerServicesItems.push(i);
        });
      });

      this.loading = false;
      return true;
    });
  }

  get_seller_servicesProv(): Promise<any> {
    this.partnerServicesItems = [];
    this.select_service_providers = [];
    const Url = this.url.baseurl + 'auth/service_providers';
    this.loading = true;
    return this._request.get(Url).toPromise().then((res: any) => {
      this.partnerServicesProv = res;
      this.partnerServicesProv.forEach((v) => {
        this.select_service_providers.push({label: v.name, value: v.id, img: v.logo});

        v.items.forEach((i) => {
          this.partnerServicesItems.push(i);
        });
      });

      this.loading = false;
      return true;
    });
  }

  get_partner_allowed_services(userID: number) {
    this.partnerAllowedServices = [];
    const Url = this.url.baseurl + 'auth/user/' + userID + '/allowed_service_items';
    this.loading = true;
    this._request.get(Url).toPromise().then((res: any) => {
      this.partnerAllowedServices = res;
      this.loading = false;
      return true;
    });
  }

  get_partner_transactions(accountId: number, page: number = 1, profile = '', extra_id = 0) {
    // this.partnerTransactions = [];
    let Url = this.url.baseurl + 'auth/accounts/' + accountId + '/transactions/' + page;
    if (profile === 'api_key') {
      Url = this.url.baseurl + 'auth/accounts/' + accountId +
        '/transactions/' + page + '?api_key=' + extra_id;
    }

    if (profile === 'seller_admin' || profile === 'seller') {
      Url = this.url.baseurl + `auth/api_keys/${extra_id}/transaction/${page}`;
    }
    this.loading = true;
    return this._request.get(Url).toPromise().then((res: any) => {
      if (profile === 'seller_admin' || profile === 'seller') {
        this.partnerTransactions = res.data;
      } else {
        this.partnerTransactions = res.transactions.data;
      }

      this.loading = false;
      return res;
    });
  }

  get_transaction_file(that, accountId: number, fromDate: string, toDate: string) {
    const Url = this.url.baseurl + 'public/accounts/' + accountId + '/transactions/' + fromDate + '/' + toDate;
    this._request.download(Url).subscribe((res: any) => {
      // console.log(res);
      that.onSuccess2(res);
    });
  }

  getSellerAgents() {
   // const requestURL = this.url.baseurl + 'auth/seller_admin/users';
    // tslint:disable-next-line:triple-equals
   const requestURL = this.authenticated.type == 'seller_admin' ? 'auth/seller_admin/users' : 'auth/client/fnf' ;
    this.loading = true;
    this._request.get(requestURL).subscribe((results: any) => {
      this.loading = false;
      console.log('agents',results);
      this.seller_agents = results;
    });
  }

  getTransactionByClaims(transaction_id, startDt, endDt, status = 'pending', page = 1) {
    this.transactions_byClaims = [];
    const requestURL = this.url.baseurl + `auth/supervisor/transactions/${page}?status=${status}` +
      `&start_at=${startDt}&end_at=${endDt}&transactionId=${transaction_id}`;
    this.loading = true;
    return this._request.get(requestURL).toPromise().then((results: any) => {
      this.loading = false;
      console.log("resultats",results);
      this.transactions_byClaims = results.data;
      return results;
    });
  }


  getTransactionInvoice(transaction_id) {
    const requestURL = this.url.baseurl + `public/transaction/${transaction_id}/facturePdf`;
    this.loading = true;
    this._request.showSpinner();
    this._request.download(requestURL).subscribe((res: any) => {
      this.loading = false;
      this._request.hideSpinner();
      if (window.navigator.msSaveOrOpenBlob) {
        console.log('navigator download');
        window.navigator.msSaveOrOpenBlob(res, 'transaction.pdf');
      } else {
        console.log('manual download');
        const fileURL = URL.createObjectURL(res);
        const a: HTMLAnchorElement = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
      }
    });
  }

  get_dashboard_data(Url: String) {
    const request_Url = this.url.baseurl + `${Url}`;
    return this._request.get(request_Url).toPromise().then((res: any) => {
      return res;
    });
  }


  get_agentXcash_list() {
    const request_Url = this.url.baseurl + 'auth/super_admin/agentxcash';
    return this._request.get(request_Url).toPromise().then((res: any) => {
      return res;
    });
  }

  get_data(url: string): Promise<any> {
    const request_Url = this.url.baseurl + url;
    return this._request.get(request_Url).toPromise().then((res: any) => {
      return res;
    });
  }

  convertObjectToFormData(form: {}, stringify = false) {
    const body = new FormData();
    for (const key in form) {
      if (form.hasOwnProperty(key) && form[key] !== 'null' && form[key] != null) {
        if (stringify) {
          body.append(key, JSON.stringify(form[key]));
        } else {
          body.append(key, form[key]);
        }
      }
    }
    return body;
  }

  updateItemWallet(that, type: string, serviceID: number, account_id = 0, data: IBuyWallet[]) {
    const loginUrL = this.url.baseurl + 'auth/service_item/' + serviceID + '/' + type + '/' + account_id;

    // const body = this.convertObjectToFormData(form, true);

    // this._request.put(loginUrL, JSON.stringify(data)).subscribe((results: any) => {
    this._request.put(loginUrL, data, true).subscribe((results: any) => {
        console.log('http response', results);
        this._request.notifySuccess('success', 'Notification', this.default_msg);
        that.onSuccess();
      }
    );
  }

  updatePartnerStatus(that, id: number, form: {}) {
    const UrL = this.url.baseurl + 'auth/user/' + id + '/active';
    this._request.post(UrL, form, true).subscribe((results: any) => {
        this._request.notifySuccess('success', 'Notification', this.default_msg);
        this.http_event.next(true);
      }, (e) => {
        this.http_event.next(false);
      }
    );
  }

  updatePartnerType(that, id: number, form: {}) {
    const UrL = this.url.baseurl + 'auth/admin/society/users/' + id + '/type';
    this._request.post(UrL, form, true).subscribe((results: any) => {
        console.log('http response', results);
        this._request.notifySuccess('success', 'Notification', this.default_msg);
        this.http_event.next(true);
      }, (e) => {
        this.http_event.next(false);
      }
    );
  }

  addPartner(that, form: {}) {
    const type = this.authenticated.type ? this.authenticated.type : UserType.PARTNER;
    const UrL = this.url.baseurl + 'auth/' + type + '/users';
    // const body = this.convertObjectToFormData(form);
    this.processData('post', that, UrL, form);
  }
  addPartnerRegistration(that, form: {}) {
    const type = this.authenticated.type ? this.authenticated.type : UserType.PARTNER;
    const UrL = this.url.baseurl + 'auth/' + type + '/usersRegistration';
    // const body = this.convertObjectToFormData(form);
    this.processData('post', that, UrL, form);
  }

  async_addPartner(that, form: {}) {
    const UrL = this.url.baseurl + 'auth/' + this.authenticated.type + '/users';
    // const body = this.convertObjectToFormData(form);
    return this.processData('async_post', that, UrL, form);
  }

  async_verserPartner(that, accountId: number, form: {}) {
    const UrL = this.url.baseurl + 'auth/' + this.authenticated.type + '/account/' + accountId;
    // const body = this.convertObjectToFormData(form);
    return this.processData('async_post', that, UrL, form);
  }

  updateAllowedServiceStatus(that, userID: number, form: number[]) {
    const loginUrL = this.url.baseurl + 'auth/user/' + userID + '/allowed_service_items';
    this._request.put(loginUrL, form, true).subscribe((results: any) => {
        console.log('http response', results);
        this._request.notifySuccess('success', 'Notification', this.default_msg);
        this.http_event.next(true);
        // that.onSuccess();
      }, (e) => {
        this.http_event.next(false);
      }
    );
  }


  applyAutoRecharge(that, form: {}) {
    const UrL = this.url.baseurl + 'auth/admin/service_items/auto_recharge';
    this.processData('post', that, UrL, form);
  }

  async_sendCreditByApiKey(that, form: {}): Promise<any> {
    this.loading = true;
    const UrL = this.url.baseurl + 'credit/send';
    return this.processData('async_post', that, UrL, form);
  }


  async_updateClaimValidateStatus(that, transaction_id: number, form: {}) {
    this.loading = true;
    const UrL = this.url.baseurl + `auth/supervisor/transactions/${transaction_id}/validate`;
    this.processData('async_put', that, UrL, form);
  }

  async_transClainTransfer(that, form: {}) {
    const UrL = this.url.baseurl + `auth/claims`;
    return this.processData('async_post', that, UrL, form);
  }

  transFacturePDFransfer(that, transaction_id: number, form: {}) {
    this.loading = true;
    const UrL = this.url.baseurl + `public/transaction/${transaction_id}/facturePdf`;
    this._request.get(UrL).subscribe((results: any) => {
        this.loading = false;
        console.log('http response', results);
        this._request.notifySuccess('success', 'Notification', this.default_msg);
        that.onSuccess();
      }
      , (e) => {
        this.loading = false;
      });
  }


  setLanguage(value) {
    this.translate.use(value);
    this.lang_event.next(value);
    localStorage.setItem(MyCONST.LANG, value);
    this.defaultLng = value;
    this.translate.get('HOME.txt.success_operation_msg').subscribe(res => {
      console.log('translate result', res);
      this.default_msg = res;
    });
    this.setMenuItems(this.raw_menuItems);

  }

  setMenuItems(data: IMenuItem[]) {
    this.raw_menuItems = data;
    const type = this.authenticated.type;
    const menus = this.env.roles[type].menu;
    data = data.filter(x => menus.indexOf(x.routing) > -1 || menus.indexOf(x.title) > -1);
    data.forEach((v, k) => {
      const val_to_translate = v.routing ? v.routing : v.title;
      const key = `HOME.menu.${val_to_translate}`;
      this.translate.get(key).subscribe(res => {
        // console.log('translated', res);
        v.title = res !== key ? res : v.title;
        data[k].title = v.title;
      });

    });
    this.menuItems = data;
    this.menuItems = data;
    // console.log('menu items', this.menuItems);
    return data;
  }

  configDEfaultLang() {
    const storedLng = localStorage.getItem(MyCONST.LANG);
    const defaultLng = storedLng ? storedLng : 'fr';
    this.defaultLng = defaultLng;
    this.translate.addLangs(['en', 'fr']);
    this.translate.setDefaultLang(defaultLng);
    // const browserLang = this.translate.getBrowserLang();
    // this.translate.use(browserLang.match(/fr|en/) ? browserLang : defaultLng);
  }

  lang(key) {
    return this.translate.instant(key);
  }

  getLocation() {
    if (window.navigator && window.navigator.geolocation) {
      window.navigator.geolocation.getCurrentPosition(
        position => {
          // this.geolocationPosition = position,
          console.log(position);
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
        },
        error => {
          switch (error.code) {
            case 1:
              console.log('Permission Denied');
              break;
            case 2:
              console.log('Position Unavailable');
              break;
            case 3:
              console.log('Timeout');
              break;
          }
        }
      );
    }
  }

  getDeviceInfo = () => this.deviceService.getDeviceInfo();

  resetLocation() {
    this.longitude = 0;
    this.latitude = 0;
  }

  deletePending_id(ids: any[], selected_db) {
    ids.forEach((id) => {
      this[selected_db].get(id).then(async (doc_row) => {
        console.log('deleting ....', id);
        await this[selected_db].remove(doc_row);
      });
    });
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    console.log('workbook', workbook);

    const jsonKeys = Object.keys(json[0]);

    const objectMaxLength = [];
    for (let i = 0; i < json.length; i++) {
      const value = json[i];
      for (let j = 0; j < jsonKeys.length; j++) {
        if (typeof value[jsonKeys[j]] === 'number') {
          objectMaxLength[j] = 10;
        } else {
          const l = value[jsonKeys[j]] ? value[jsonKeys[j]].length : 0;
          objectMaxLength[j] = objectMaxLength[j] >= l ? objectMaxLength[j] : l;
        }
      }

      const key = jsonKeys;
      for (let j = 0; j < key.length; j++) {
        objectMaxLength[j] =
          objectMaxLength[j] >= key[j].length
            ? objectMaxLength[j]
            : key[j].length;
      }
    }

    const wscols = objectMaxLength.map(w => {
      return {width: w};
    });

    // worksheet['!cols'] = wscols;
    workbook.Sheets['data']['!cols'] = wscols;


    // workbook.Sheets['data']['!ref'] = json;
    // ws['!ref'] = wscols;
    const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  transactionStatusDecoration(status: string) {
    let info = {title: 'no status', color: 'white'};
    switch (status) {
      case 'pending':
        info = {title: this.translate.instant('HOME.txt.on_pending'), color: 'yellow'};
        break;
      case 'success':
        info = {title: this.translate.instant('HOME.txt.succeeded'), color: '#5cb85c'};
        break;
      case 'failed':
        info = {title: this.translate.instant('HOME.txt.failed'), color: '#731f3f'};
        break;
    }
    return info;
  }

}
